/** "Connect the Jotform" (or the jail system): make the secret link to paste into the other system. */
import { useState } from 'react';
import { api } from '../shared/api.ts';
import { Card, ErrorBox, Notice, useAction, useLoad } from '../shared/ui.tsx';
import { when } from './common.tsx';

export function HookLinkCard({ title, settings, rotate, what, detail, jotform = true }: { title: string; settings: string; rotate: string; what: string; detail: string; jotform?: boolean }) {
  const r = useLoad(() => api.get<any>(settings).catch(() => null));
  const [path, setPath] = useState<string | null>(null);
  const a = useAction();
  if (!r.data) return null;
  const j = r.data.jotform ?? r.data.feed;
  return (
    <Card title={title}>
      <div className="stack sm">
        <p className="small">
          {jotform ? (
            <>
              In Jotform, open the {what} form → <strong>Settings → Integrations → WebHooks</strong>, paste the link below and save.{' '}
            </>
          ) : (
            <>Give this link to the {what} vendor; they post each record to it as JSON. </>
          )}
          {detail}
        </p>
        <p className="small muted">
          {j.configured ? `Link made ${when(j.createdAt)}.` : 'No link yet.'} {j.lastReceivedAt ? `Last one received ${when(j.lastReceivedAt)}.` : j.configured ? 'Nothing received yet.' : ''}
        </p>
        {path && (
          <Notice tone="ok">
            <div className="small">Copy this now (it isn’t shown again):</div>
            <code className="esc-link">{location.origin + path}</code>
          </Notice>
        )}
        <ErrorBox error={a.error} />
        <div>
          <button
            className="btn"
            disabled={a.busy}
            onClick={() => (!j.configured || window.confirm('Make a new link? The old one stops working.')) && a.run(async () => (setPath((await api.post<{ path: string }>(rotate)).path), r.reload()))}
          >
            {j.configured ? 'Make a new link' : 'Make the link'}
          </button>
        </div>
      </div>
    </Card>
  );
}
